export default __webpack_public_path__ + "static/media/nothing-here.2c990499.png";